<!--
* UIID: UI-CAAS-COM-110
* UI Name: Create Company
* Modify Date: 2020/06/22
-->
<template>
  <v-row justify="center">
    <v-dialog
      v-model="detailDialog"
      max-width="888px"
      persistent
      content-class="company-detail-dialog"
    >
      <template v-slot:activator="{ on }">
        <v-btn text v-on="on" small @click="disableClose">
          <v-icon x-small class="mr-4">{{ btnIcon }}</v-icon>
          {{ btnTxt }}<v-spacer></v-spacer>
        </v-btn>
      </template>
      <v-card class="title-header-company">
        <v-card-title class="content-header-company pa-5 ml-5">
          <span class="headline white--text">{{ title }}</span>
        </v-card-title>
      </v-card>
      <v-card class="v-dialog-1 dialog-company-Detail add-map-layout-dialog">
        <system-progress
          :sysloading="isLoading"
          :sysloadingTitle="sysloadingTitle"
        ></system-progress>
        <v-row>
          <v-col cols="7" class="pb-0 pl-6">
            <v-label>{{ $t('lbl.company.companyInfo') }}</v-label>
          </v-col>
          <v-col cols="5" class="pl-6 pb-0">
            <v-label>{{ $t('lbl.identification.ediInfo') }}</v-label>
          </v-col>
        </v-row>
        <v-card-text class="pa-0">
          <v-row>
            <v-col cols="7">
              <v-form ref="form" class="dialog-content form-identification form-company">
                <v-row class="ml-0 mr-0">
                  <v-col cols="12" class="pa-0">
                    <v-label
                      ><v-icon x-small class="mr-1">fa fa-asterisk</v-icon
                      >{{ $t('lbl.company.companyId') }}</v-label
                    >
                    <v-text-field
                      ref="compId"
                      v-model="getValue.compId"
                      :rules="[
                        validationUtils.required,
                        validationUtils.emailIdRules,
                        validationUtils.max(50),
                      ]"
                      :error="dupErr"
                      :error-messages="dupErrMsg"
                      @input="clearDupErr()"
                      heigth="30"
                      solo
                      class="text-field-company"
                      :readonly="!!getValue.id"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="ml-0 mr-0">
                  <v-col cols="12" class="pa-0">
                    <v-label
                      ><v-icon x-small class="mr-1">fa fa-asterisk</v-icon
                      >{{ $t('lbl.company.companyName') }}</v-label
                    >
                    <v-text-field
                      ref="compNm"
                      v-model="getValue.compNm"
                      :rules="rules.compNm"
                      heigth="30"
                      solo
                      class="text-field-company"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="ml-0 mr-0">
                  <v-col cols="12" class="pa-0">
                    <v-label
                      ><v-icon x-small class="mr-1">fa fa-asterisk</v-icon
                      >{{ $t('lbl.company.contactPerson') }}</v-label
                    >
                    <v-text-field
                      ref="cnttPrn"
                      v-model="getValue.cnttPrn"
                      :rules="rules.cnttPrn"
                      heigth="30"
                      solo
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="ml-0 mr-0">
                  <v-col cols="12" class="pa-0">
                    <v-row class="ma-0 check-row-partner">
                      <v-label>{{ $t('lbl.company.emailAddress') }}</v-label>
                    </v-row>
                    <v-row class="ma-0">
                      <!-- <v-col cols="6" class="map-text-field pa-0">
                        <v-text-field
                          ref="emailF"
                          v-model="getValue.emailF"
                          :rules="rules.emailF"
                          heigth="30"
                          solo
                        ></v-text-field>
                      </v-col>
                      <v-col cols="6" class="map-text-field inline-block-company pa-0">
                        <div class="mr-3 ml-3 pt-2">
                          <span class="field-label">
                            @
                          </span>
                        </div>
                        <v-text-field
                          ref="emailT"
                          v-model="getValue.emailT"
                          heigth="30"
                          :rules="rules.emailT"
                          :disabled="getValue.id ? true : false"
                          solo
                          :error="dupErr"
                          :error-messages="dupErrMsg"
                          @input="clearDupErr()"
                        ></v-text-field>
                      </v-col> -->
                      <v-col cols="12" class="map-text-field inline-block-component pa-0">
                        <v-text-field
                          ref="email"
                          v-model="getValue.email"
                          :rules="[validationUtils.emailRules]"
                          :maxlength="50"
                          :readonly="!!getValue.id"
                          @input="setCheckStatus()"
                          heigth="30"
                          solo
                        ></v-text-field>
                        <v-btn
                          class="ml-3 check-btn-partner"
                          :color="checkBtnColor"
                          @click="checkEmailCompany()"
                          v-if="!getValue.id"
                        >
                          <v-icon x-small>{{ checkBtnIcon }}</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row class="ml-0 mr-0">
                  <v-col cols="12" class="pa-0">
                    <v-label>{{ $t('lbl.identification.remark') }}</v-label>
                    <v-textarea
                      ref="remark"
                      v-model="getValue.remark"
                      counter="200"
                      solo
                    ></v-textarea>
                  </v-col>
                </v-row>
                <v-row
                  class="ml-0 mr-0"
                  style="height: 37px;"
                  v-if="Number($cookies.get('use-grade')) === 9"
                >
                  <v-col cols="6" class="pa-0">
                    <v-checkbox
                      v-model="getValue.spFlg"
                      ref="spFlg"
                      label="Company Management"
                      dense
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="6" class="pa-0 pl-5">
                    <v-checkbox
                      v-model="getValue.compRepoUseFlg"
                      ref="compRepoUseFlg"
                      label="Use DLB Functions"
                      dense
                    ></v-checkbox>
                  </v-col>
                </v-row>
              </v-form>
            </v-col>
            <!-- /*
            * 2021.20.07 203737 SPKA-159 issue 107 Add "Character Set" Item 
            */ -->
            <v-col cols="5" class="pl-1">
              <v-row class="ml-0 mb-6">
                <v-col cols="12">
                  <v-form
                    ref="formEDI"
                    class="dialog-content form-identification edi-iden-company-list pr-0 pb-4"
                  >
                    <v-row class="ml-0 mr-0">
                      <v-col lg="6" class="pa-0">
                        <v-label>{{ $t('lbl.identification.ediID') }}</v-label>
                      </v-col>
                      <v-col lg="4" class="pa-0 ml-2">
                        <v-label>{{ $t('lbl.identification.qualifier') }}</v-label>
                      </v-col>
                      <v-col lg="1" class="pa-0 ml-3 mr-0">
                        <v-icon dense @click="addEDI()">
                          mdi-plus
                        </v-icon>
                      </v-col>
                    </v-row>
                    <v-row
                      class="ml-0 mr-0 mb-2 edi-identification custom-bg-input"
                      v-show="item.status != 'D'"
                      v-for="(item, index) in listEDI"
                      :key="item.id"
                    >
                      <v-col lg="6" class="pa-0">
                        <v-text-field
                          :ref="'EDI_' + item.id"
                          :maxlength="50"
                          solo
                          hide-details
                          v-model="item.srId"
                          :disabled="item.status != 'I'"
                          :readonly="item.status != 'I'"
                          :class="[item.status != 'I' ? 'custome-edi-not-allowed' : '']"
                        ></v-text-field>
                      </v-col>
                      <v-col lg="4" class="pa-0 ml-2">
                        <v-text-field
                          :ref="'EDI_' + item.id + '_' + item.id"
                          :maxlength="50"
                          solo
                          hide-details
                          v-model="item.srQlfr"
                          @change="changeEDI(item, index)"
                          :disabled="item.numOfUse > 0"
                          :readonly="item.numOfUse > 0"
                          :class="[item.numOfUse > 0 ? 'custome-edi-not-allowed' : '']"
                        ></v-text-field>
                      </v-col>
                      <v-col lg="1" class="pa-0 ml-3 mr-0 mt-2">
                        <v-tooltip top :disabled="item.numOfUse == 0">
                          <template v-slot:activator="{ on }">
                            <div v-on="on" class="btn-tooltip">
                              <v-icon
                                dense
                                @click="removeEDI(item, index)"
                                :disabled="item.numOfUse > 0"
                              >
                                mdi-minus
                              </v-icon>
                            </div>
                          </template>
                          <span v-html="$t('lbl.processSetup.ediInUseWF')"></span>
                        </v-tooltip>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-col>
              </v-row>
              <v-row class="ml-0 mb-2">
                <v-col cols="12" class="pb-0">
                  <v-label>{{ $t('lbl.common.characterSet') }}</v-label>
                </v-col>
              </v-row>
              <v-row class="ml-0">
                <v-col cols="12">
                  <v-form
                    ref="formEDI"
                    class="dialog-content form-identification character-set pr-0"
                  >
                    <v-row class="ml-0 mr-0">
                      <v-col lg="12" class="pa-0">
                        <v-select
                          v-model="getValue.chrSet"
                          class="custom-selectbox select-character-set"
                          :placeholder="$t('lbl.common.characterSet')"
                          :items="characterSetList"
                          height="30"
                          hide-details
                          dense
                          solo
                        ></v-select>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider class="ml-0 mr-0 mt-3 divder-popup" inset></v-divider>
        <v-row class="ml-0 mr-0 pt-2">
          <v-col class="button-col action-col character-set pr-0" lg="12">
            <div class="btn-form-control text-right">
              <v-btn class="btn btn-delete btn-popup" @click="close()">{{
                $t('lbl.company.close')
              }}</v-btn>
              <v-btn class="btn btn-popup-search btn-popup" color="primary" @click="save()">{{
                $t('lbl.company.save')
              }}</v-btn>
            </div>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
    <dialogWindow
      ref="companySaveDialog"
      size="max"
      :detail="checkDialogInfo"
      :color="checkDialogColor"
      @select-ok="removeDialog()"
    >
    </dialogWindow>
  </v-row>
</template>

<script>
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';
import SystemProgress from '@/vue-dlb/components/SystemProgress.vue';
import { mapState } from 'vuex';

export default {
  components: {
    dialogWindow,
    SystemProgress,
  },
  props: {
    btnTxt: {
      default: '',
    },
    btnIcon: {
      default: '',
    },
    title: {
      default: '',
    },
    dataValue: {
      default: function() {
        return {
          compId: '',
          compNm: '',
          cnttPrn: '',
          email: '',
          // emailF: '',
          // emailT: '',
          remark: '',
          chrSet: '',
        };
      },
    },
  },
  data() {
    return {
      detailDialog: false,
      value: {},
      checkResult: '',
      idFocus: '',
      rules: {
        compNm: [
          (v) => !!v || 'Company Name Address is required',
          (v) => !v || v.length <= 50 || 'Company Name max length is 50.',
        ],
        cnttPrn: [
          (v) => !!v || 'Contact Person is required',
          (v) => !v || v.length <= 100 || 'Contact Person max length is 100.',
        ],
        // emailF: [
        //   (v) => !!v || 'Company Email Local-part is required',
        //   (v) => !v || v.length <= 45 || 'Company Email ID max length is 45.',
        // ],
        // emailT: [
        //   (v) => !!v || 'Company Email Domain is required',
        //   (v) => !v || v.length <= 50 || 'Email Address max length is 50.',
        //   (v) => !v || /.+\..+/.test(v) || 'Company Email Domain must be valid',
        // ],
        remark: [(v) => !v || v.length <= 200 || 'Remark max length is 200.'],
      },
      isLoading: false,
      formHasErrors: false,
      dupErr: false,
      dupErrMsg: '',
      checkDialogInfo: '',
      checkDialogColor: 'success',
      listEDI: [],
      characterSetList: [],
      checkBtnColor: 'secondary',
      checkBtnIcon: 'fa fa-question',
    };
  },

  watch: {
    detailDialog() {
      // 팝업이 열리면 드랍다운 메뉴가 닫히지 않도록 close가 되지 않도록 하는 로직 추가
      // 팝업 컨텐츠를 드래그할 경우 팝업이 닫히는 문제를 해결하기 위해
      // 상위 컴포넌트에서 컴포넌트 선언 시 이 이벤트를 받지 않으면, 여기서 발생시킨 이벤트는 버려짐
      this.detailDialog ? this.$emit('disable-close') : this.$emit('enable-close');
      if (this.detailDialog) {
        this.initializedData();
        if (this.getValue.id) this.getEDIList();
      }
    },
  },

  computed: {
    ...mapState('common', {
      sysloadingTitle: 'sysloadingTitle',
    }),
    getValue() {
      return this.value;
    },
  },

  created() {
    this.initializedData();
    if (this.getValue.id) this.getEDIList();
    this.getCharacterSetList();
  },

  methods: {
    addEDI() {
      let index = this.listEDI.length > 0 ? this.listEDI[this.listEDI.length - 1].id + 1 : 1;
      // 2021.5.27 203728 SPKA-123 remove default ZZZ
      this.listEDI.push({ id: index, srId: '', srQlfr: '', status: 'I', numOfUse: 0 });
    },
    removeEDI(item, index) {
      if (item.status == 'I') {
        this.listEDI.splice(index, 1);
      } else {
        this.listEDI[index].status = 'D';
      }
    },
    // 2021.5.7 203728 Add update EDI
    changeEDI(item, index) {
      if (item.status != 'I') {
        this.listEDI[index].status = 'U';
      }
    },
    getEDIList() {
      // 2021.3.30 203728 Get EDI list
      this.$store.dispatch('getCompanyEdiListNew', { companyID: this.getValue.compId }).then(() => {
        this.listEDI = [];
        if (this.$store.getters.compEdiIdList.length > 0) {
          this.$store.getters.compEdiIdList.map((e, i) => {
            this.listEDI.push({
              id: i + 1,
              srId: e.srId,
              srQlfr: e.srQlfr,
              status: e.status,
              numOfUse: e.numOfUse,
            });
          });
        }
      });
    },
    // 2021.3.16 203728 SPKA-52 => bug 13
    disableClose() {
      this.$emit('close-check', { value: false });
    },
    initializedData() {
      if (this.$refs.form !== undefined) {
        this.$refs.form.reset();
      }

      if (
        this.dataValue !== undefined &&
        this.dataValue !== null &&
        JSON.stringify(this.dataValue) !== JSON.stringify({})
      ) {
        console.log(this.dataValue);
        this.value = JSON.parse(JSON.stringify(this.dataValue));
        this.value.spFlg = this.dataValue.spFlg === 'Y' ? true : false;
        this.value.compRepoUseFlg = this.dataValue.compRepoUseFlg === 'Y' ? true : false;
      } else {
        this.resetValue();
      }
    },
    checkEmailCompany() {
      if (this.getValue.email.length > 0) {
        this.$store.dispatch('checkEmailCompany', this.getValue).then((res) => {
          if (!res) {
            this.setCheckStatus('S');
          } else {
            this.setCheckStatus('E');
          }
        });
      }
    },
    setCheckStatus(val) {
      if (val === 'S') {
        this.checkBtnColor = 'success';
        this.checkBtnIcon = 'fa fa-check';
      } else if (val === 'E') {
        this.checkBtnColor = 'error';
        this.checkBtnIcon = 'fa fa-times';
      } else {
        this.checkBtnColor = 'secondary';
        this.checkBtnIcon = 'fa fa-question';
      }
    },
    resetValue() {
      this.value = {
        compId: '',
        compNm: '',
        cnttPrn: '',
        email: '',
        // emailF: '',
        // emailT: '',
        remark: '',
        chrSet: '',
      };
    },
    save() {
      try {
        this.formHasErrors = false;
        const checkList = ['compId', 'compNm', 'cnttPrn'];
        Object.keys(this.getValue).forEach((key) => {
          if (this.$refs[key] !== undefined && checkList.includes(key)) {
            if (!this.getValue[key] || this.getValue[key] === '') {
              this.formHasErrors = true;
              this.$refs[key].validate(true);
            }
          }
        });

        if (this.formHasErrors) return;

        if (
          !this.getValue.id &&
          this.getValue.email.length > 0 &&
          this.checkBtnColor != 'success'
        ) {
          this.checkDialogInfo = this.$t('msg.company.chkCompDup');
          this.checkDialogColor = 'validation';
          this.$refs.companySaveDialog.dialog = true;
          return;
        }

        if (!this.formHasErrors) {
          this.isLoading = true;
          // 2021.5.7 203728 Remove check Qual
          let index = this.listEDI.find((e) => e.srId == '');
          if (index) {
            return this.$refs[
              `EDI_${index.id}${index.srId == '' ? '' : '_' + index.id}`
            ][0].focus();
          }

          let arrChk = this.listEDI.map((e) => {
            return e.srId + e.srQlfr;
          });
          let isDuplicate = arrChk.findIndex((e, i) => {
            return arrChk.indexOf(e) != i;
          });

          if (isDuplicate > -1) {
            this.checkDialogInfo = 'EDI Identification is duplicate.';
            this.checkDialogColor = 'validation';
            this.isLoading = false;
            this.$refs.companySaveDialog.dialog = true;
            this.idFocus = `EDI_${isDuplicate + 1}`;
            return;
          }

          this.value.edi_list = this.listEDI.filter((e) => e.status);
          this.value.edi_list.map((e) => {
            e.srQlfr = e.srQlfr.trim();
          });

          if (this.getValue.id) {
            this.$store
              .dispatch('updateCompany', this.getValue)
              .then(() => {
                this.checkDialogInfo = `${this.getValue.compNm} has been updated successfully.`;
                this.checkDialogColor = 'success';
                this.isLoading = false;
                this.$refs.companySaveDialog.dialog = true;
              })
              .catch((err) => {
                this.checkDialogInfo = `Exception occured updating ${this.getValue.compNm} company info.\nReason: ${err}`;
                this.checkDialogColor = 'error';
                this.isLoading = false;
                this.$refs.companySaveDialog.dialog = true;
              });
          } else {
            this.$store.dispatch('checkCompany', this.getValue).then(() => {
              if (!this.$store.getters.duplicate.compId) {
                this.$store
                  .dispatch('insertCompany', this.getValue)
                  .then(() => {
                    this.checkDialogInfo = `${this.getValue.compNm} has been created successfully.`;
                    this.checkDialogColor = 'success';
                    this.isLoading = false;
                    this.$refs.companySaveDialog.dialog = true;
                  })
                  .catch((err) => {
                    this.checkDialogInfo = `Exception occured creating ${this.getValue.compNm} company info.\nReason: ${err}`;
                    this.checkDialogColor = 'error';
                    this.isLoading = false;
                    this.$refs.companySaveDialog.dialog = true;
                  });
              } else {
                // alert('Duplicated company.');
                // this.$refs.emailT.error = true;
                this.dupErr = true;
                this.isLoading = false;
                this.dupErrMsg = `${this.getValue.compNm} is already exist.`;
              }
            });
          }
        }
      } catch (err) {
        this.checkDialogInfo = `Exception occured.\nReason: ${err}`;
        this.checkDialogColor = 'error';
        this.isLoading = false;
        this.$refs.companySaveDialog.dialog = true;
      }
    },

    close() {
      this.resetValue();
      this.$refs.form.reset();
      this.listEDI = [];
      this.detailDialog = false;
      // 2021.3.16 203728 SPKA-52 => bug 13
      this.$emit('close-check', { value: true });
    },

    clearDupErr() {
      this.dupErr = false;
      this.dupErrMsg = '';
    },

    removeDialog() {
      if (this.idFocus) {
        let self = this;
        return setTimeout(() => {
          self.$refs[self.idFocus][0].focus();
        }, 300);
      }
      if (this.checkDialogColor != 'success') return;

      this.resetValue();
      this.$refs.companySaveDialog.dialog = false;
      this.listEDI = [];
      this.detailDialog = false;
      // 2021.3.16 203728 SPKA-52 => bug 13
      this.$emit('close-check', { value: true });
      this.$emit('refreshList');
    },
    getCharacterSetList() {
      this.$store.dispatch('caascommon/getComCdList', { grpCd: 'C06' }).then(() => {
        let characterSetList = this.$store.getters['caascommon/comCdList'];
        characterSetList.map((item) => {
          this.characterSetList.push({ text: item.text, value: item.value });
        });
      });
    },
  },
};
</script>
<style>
.inline-block-company {
  display: flex !important;
}
.dialog-company-Detail {
  padding: 10px 30px 20px;
}
.theme--light .dialog-company-Detail .v-card__text {
  background-color: #fafcff !important;
}
.theme--dark .form-company {
  background-color: #292c35 !important;
}
.form-company {
  padding: 20px 15px 15px;
}
.title-header-company {
  vertical-align: middle !important;
}
.dialog-company-Detail .button-col {
  padding-top: 10px;
}
.theme--dark .dialog-company-Detail .v-label {
  color: #ffffff !important;
}
.theme--light .dialog-company-Detail .v-label {
  color: #000000 !important;
}
.content-header-company {
  height: 50px !important;
  padding: 0px 0px 0px 18px !important;
  font-weight: 700;
  font-size: 24px;
  letter-spacing: 0.4375px;
  font-family: 'Open Sans' !important;
}
.theme--dark .content-header-company .headline {
  font-size: 1.5rem !important;
  font-weight: bold;
  line-height: 29px;
}
.theme--light .content-header-company .headline {
  font-size: 24px !important;
  font-weight: 700;
  line-height: 33px;
  color: #000000 !important;
}
.company-btn {
  font-size: 13px;
}
.dialogs .dialog-drag.customerEDIInfo .dialog-body {
  padding-top: 0px !important;
}
.edi-iden-company-list {
  min-height: 270px;
  max-height: 270px;
  overflow-y: auto;
  padding: 20px 15px 15px;
}
.custome-edi-not-allowed input {
  cursor: not-allowed;
}
.edi-identification
  .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  height: 34px !important;
}
.v-dialog:not(.v-dialog--fullscreen).company-detail-dialog {
  max-height: 95%;
  top: 10px;
}
</style>
